const obimg = new IntersectionObserver((entries) => {
  if (entries[0].intersectionRatio <= 0) return;
  const img = entries[0].target;
  const src = img.getAttribute("data-src");
  img.setAttribute("src", src);
  img.classList.add("layzload");
  obimg.unobserve(img);
});
const obDiv = new IntersectionObserver((entries) => {
  const div = entries[0].target;
  if (entries[0].intersectionRatio <= 0) {
    div.classList.remove("show");
    return;
  }
  div.classList.toggle("show");
  obDiv.unobserve(div);
});

const addLayzload = (el) => {
  const myob = el.nodeName == "IMG" ? obimg : obDiv;
  myob.observe(el);
};

export default {
  bind(el) {
    addLayzload(el);
  },
  inserted(el) {
    addLayzload;
  },
};
